import { render, staticRenderFns } from "./StatusReasonDialog.vue?vue&type=template&id=b4e49912"
import script from "./StatusReasonDialog.vue?vue&type=script&lang=js"
export * from "./StatusReasonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports